import React, { useEffect, useState, useRef } from 'react'
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as d from "../../../reducers/domainReducer";
import { getFirstName, isRxRoute } from "../../../helpers/formatting";
import { Icon, Typography, Divider, LinkList, LinkText, Tooltip, Drawer } from "../../ecosystem";
import * as types from "../../../constants/actionTypes";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import ProxySelectorCarousel from '../../common/Proxy/ProxySelectorCarousel';
import DrawerProxySelector from './DrawerProxySelector';
import DrawerProxySection from './DrawerProxySection';
import DrawerProxyItem from './DrawerProxyItem';

const MyChartProxySelector = (props) => {
    const allTab = "All";
    /*const activeAllTab = "All".toLowerCase();*/
    const {
        age,
        primaryUser,
        myChartUsers,
        isMobile,
        history,
        hasMyChart,
        currentMyChartUser,
        currentPharmacyUser,
        isShowAllUsers,
        isOpenHeroSectionToolTip,
        updateonBoardingToolTipState,
        bundle
    } = props;
    const isMyChartProxyAvailable = hasMyChart && myChartUsers.length > 0;
    const isAdult = age && age > 17 ? true : false;
    const [activeTab, setActiveTab] = useState(allTab);
    const [activeTabName, setActiveTabName] = useState('');
    const [activeUser, setActiveUser] = useState('');
    const [userList, setUserList] = useState([]);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

    const pathname = history && history.location ? history.location.pathname : '/';

    const isPharmacyPage = (bundle === "pharmacy" || pathname === '/pharmacy' || isRxRoute(pathname));

    useEffect(() => {
        setUserList([primaryUser].concat(myChartUsers));
        if (isShowAllUsers) {
            setActiveTab(allTab);
            setActiveTabName(allTab);
        }
    }, [isShowAllUsers]);

    useEffect(() => {
        if (!isShowAllUsers && currentMyChartUser && currentMyChartUser.wprInternalID && activeTab !== currentMyChartUser.wprInternalID && userList &&
            userList.length > 0) {
            setActiveTab(currentMyChartUser.wprInternalID);
            setActiveTabName(currentMyChartUser.displayName);
        }
    }, [currentMyChartUser, isShowAllUsers, userList]);

    useEffect(() => {
        setActiveUser(currentPharmacyUser && isPharmacyPage ? currentPharmacyUser : currentMyChartUser ? currentMyChartUser : '');
    }, [currentPharmacyUser, currentMyChartUser]);

    const handleChangeUser = (user, isPrimary) => {
        if (user === allTab) {
            setActiveTab(allTab);
            setActiveTabName(allTab);
            props.switchToMyChartUser(primaryUser, true, 0);
        }
        else {
            setActiveTab(user.wprInternalID);
            setActiveTabName(user.displayName);
        }

        if (!isPrimary) {
            onMyChartUserSelected(user);
        }
        else if (isPrimary && user !== allTab) {
            let isAllSelected = false;
            onPrimaryUserSelected(primaryUser, isAllSelected);
        }
    }

    const onPrimaryUserSelected = (user, isAll) => {
        if (blockUserSwitch()) {
            openModal();
        } else {
            window.userToSwitch = { ...user, isPrimary: true };
            switchToPrimaryUser(isAll);
        }
    }

    const onMyChartUserSelected = (user) => {

        if (blockUserSwitch()) {
            openModal();
        } else {
            window.userToSwitch = { ...user, isPrimary: false };
            switchToMyChartUser();
        }
    }

    const switchToPrimaryUser = (isAll) => {
        const user = window.userToSwitch;
        const { bundle } = props;
        props.switchToMyChartUser(user, isAll, 0);
        logUI("MBHWeb.Proxy.PrimaryUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
        window.userToSwitch = null;
    }

    const switchToMyChartUser = (thisObj) => {
        const user = window.userToSwitch || "";
        const { currentMyChartUser, bundle } = props;
        if (user !== activeUser || user.externalId !== currentMyChartUser.externalId) {
            props.switchToMyChartUser(user, false, user.index ? user.index : 0);
            logUI("MBHWeb.Proxy.MyChartUserSelected", new Date(), Tools.getURLPath(), JSON.stringify({ user, activeUser, bundle }));
            window.userToSwitch = null;
        }
    }

    const blockUserSwitch = () => {
        return props && props.history && props.history.location && props.history.location.pathname && props.history.location.pathname.toLowerCase().indexOf("/findcare/vaccine") !== -1;
    }

    const openModal = () => {
        logUI("MBHWeb.UI.Header.Proxy.SwitchBlocked", new Date(), Tools.getURLPath());
        setModalVisible(true);
    }

    const tooltipText = "Now there’s an even easier way to view and manage healthcare for every member of your family.";

    const tooltipLinkText = "Continue";

    const noProxyView = (
        <div className={"mychart-proxy-selector mychart-proxy-selector--no-proxy"}>
            <Tooltip open={!isMyChartProxyAvailable && isOpenHeroSectionToolTip}
                text={tooltipText}
                tooltipId="add-proxy-mob-tooltip"
                linkText={tooltipLinkText}
                variant="spotlight"
                placement={isMobile ? 'top-start' : 'top'}
                linkOnClick={
                    () => {
                        updateonBoardingToolTipState();
                    }
                }>
                <div className={`no-proxy__add-btn`}>
                    <LinkText
                        to={{ pathname: '/familymanagement' }}
                        disabled={!isAdult}
                    >
                        <Icon
                            name="new-patient"
                            size="medium"
                            disabled={!isAdult}
                        />
                        <div className="divider-underline" />
                    </LinkText>
                </div>
            </Tooltip>
        </div>);

    return (
        <>{isMyChartProxyAvailable
            ? <>
                <div className="mychart-proxy-selector">
                    <Tooltip open={isMyChartProxyAvailable && isOpenHeroSectionToolTip}
                        text={tooltipText}
                        tooltipId="proxy-selector-tooltip"
                        linkText={tooltipLinkText}
                        variant="spotlight"
                        placement={isMobile ? 'top-start' : 'top'}
                        linkOnClick={
                            () => {
                                updateonBoardingToolTipState();
                            }
                        }
                    >
                        <div className={"mychart-proxy-selector__content"}>
                            {isMobile
                                ? <>
                                    <button type="button" className="mychart-proxy-selector__hero-btn--mobile" onClick={() => setMobileMenuOpen(!isMobileMenuOpen)} >
                                        <div>
                                            {activeTab === "All" &&
                                                <Icon
                                                    color={"$color-primary-a3"}
                                                    name="proxy"
                                                    size="medium"
                                                />
                                            }
                                            <Typography type="cta-03" bold color="$color-primary-a3">  {getFirstName(activeTabName)} </Typography>
                                            <div className="divider-underline" />
                                        </div>

                                        <Icon
                                            color="$color-primary-a2"
                                            name="chevron-down"
                                            size="small"
                                        />
                                    </button>
                                    <DrawerProxySelector
                                        name={primaryUser && primaryUser.displayName}
                                        open={isMobileMenuOpen}
                                        isAdult={isAdult}
                                        toggle={() => setMobileMenuOpen(false)}
                                        onAddFamilyClick={() => {
                                            logUI("MBHWeb.UI.MobileAllUserMenu.Clicked", new Date(), Tools.getURLPath());
                                            history.push("/proxymanagement");
                                        }}
                                    >
                                        {primaryUser &&
                                            <DrawerProxySection
                                                heading="Your Account"
                                            >
                                                <DrawerProxyItem
                                                    name={getFirstName(primaryUser.displayName)}
                                                    showViewing={!isShowAllUsers && activeUser && activeUser.wprInternalID && primaryUser.wprInternalID && primaryUser.wprInternalID === activeUser.wprInternalID}
                                                    onClick={() => {
                                                        handleChangeUser(primaryUser, true);
                                                        setMobileMenuOpen(false);
                                                        logUI("MBHWeb.UI.MobileAllUserMenu.Clicked", new Date(), Tools.getURLPath());
                                                    }}
                                                />
                                            </DrawerProxySection>
                                        }
                                        <DrawerProxySection
                                            heading="Family Medical Records"
                                        >
                                            <DrawerProxyItem
                                                name={"View All"}
                                                showViewing={isShowAllUsers}
                                                onClick={() => {
                                                    handleChangeUser("All", true);
                                                    setMobileMenuOpen(false);
                                                    logUI("MBHWeb.UI.MobileAllUserMenu.Clicked", new Date(), Tools.getURLPath());
                                                }}
                                            />
                                            <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />

                                            {userList && userList.map((user, index) => {
                                                return (<React.Fragment key={"WebUserList_" + index}>
                                                    {index !== 0 &&
                                                        <> <DrawerProxyItem
                                                            name={getFirstName(user.displayName)}
                                                            showViewing={!isShowAllUsers && activeUser && activeUser.externalId && user.externalId && user.externalId === activeUser.externalId}
                                                            onClick={() => {
                                                                handleChangeUser(user, primaryUser.wprInternalID === user.wprInternalID);
                                                                setMobileMenuOpen(false);
                                                                logUI("MBHWeb.UI.MobileAllUserMenu.Clicked", new Date(), Tools.getURLPath());
                                                            }}
                                                            user={user}
                                                        />
                                                            {index !== (userList.length - 1) && <Divider mTop="xsmall" mBottom="xsmall" mHorizontal="none" />}
                                                        </>}
                                                </React.Fragment>)
                                            }
                                            )}
                                        </DrawerProxySection>
                                    </DrawerProxySelector>
                                    {/*<MobileAllUserMenu
                                    isOpen={isMobileMenuOpen}
                                    userList={userList}
                                    primaryUser={primaryUser}
                                    setMobileMenuOpen={setMobileMenuOpen}
                                    handleChangeUser={handleChangeUser}
                                    activeTab={activeTab}
                                />*/}
                                </>
                                :
                                <ProxySelectorCarousel
                                    activeTab={activeTab}
                                    allTab={allTab}
                                    userList={userList}
                                    handleChangeUser={handleChangeUser}
                                />
                            }
                        </div>
                    </Tooltip>
                </div>
            </>
            : noProxyView
        }</>
    )
}

const MobileAllUserMenu = (props) => {
    const { isOpen, userList, primaryUser, setMobileMenuOpen, handleChangeUser } = props;
    return <>
        <Drawer
            title="Select a Family Member"
            open={isOpen}
            toggle={() => setMobileMenuOpen(false)}
        >
            <div className={"mobile-all-user-menu "}>
                <div className="patient-heading">
                    <Typography type="heading-05" color="$color-primary-a2">{primaryUser.displayName},</Typography>
                </div>

                <div className="proxy-mobile-title">
                    <Typography type="heading-02" color="$color-primary-a2">Who would you like to view info for?</Typography>
                    <div className="divider-underline" />
                </div>

                <div className="proxy-selector__links">
                    <>
                        <LinkList
                            list={[
                                {
                                    as: <button type="button"></button>,
                                    text: "View All",
                                    onClick: () => {
                                        handleChangeUser("All", true);
                                        setMobileMenuOpen(false);
                                        logUI("MBHWeb.UI.MobileAllUserMenu.Clicked", new Date(), Tools.getURLPath());
                                    }
                                },
                            ]}
                        /><Divider size="auto" mTop="xsmall" mLeft="none" />
                    </>
                    {userList && userList.map((user, index) =>
                        <div key={"WebUserList_" + index}>
                            <LinkList

                                list={[

                                    {
                                        as: <button></button>,
                                        text: getFirstName(user.displayName),
                                        onClick: () => {
                                            handleChangeUser(user, primaryUser.wprInternalID === user.wprInternalID);
                                            setMobileMenuOpen(false);
                                            logUI("MBHWeb.UI.MobileAllUserMenu.Clicked", new Date(), Tools.getURLPath());
                                        }
                                    },
                                ]}
                            /> <Divider size="auto" mTop="xsmall" mLeft="none" />

                        </div>

                    )
                    }
                    <>
                        <LinkList
                            list={[
                                {
                                    text: "+Add or Grant Family Access",
                                    to: "/proxymanagement",
                                    onClick: () => { logUI("MBHWeb.UI.MobileAllUserMenu.Clicked", new Date(), Tools.getURLPath()); }

                                },
                            ]}
                        />
                    </>
                </div>
            </div>
        </Drawer>
    </>
}


const mapStateToProps = (state) => {
    let pl = [];

    if (state.domain.pl) {
        state.domain.pl.forEach((c, index, arr) => {
            pl.push(d.hydrateProxyUser(c));
        });
    }

    if (pl.length > 0) {
        pl.shift();
    }

    return {
        myChartUsers: pl,
        hasMyChart: state.domain.hm,
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        primaryUser: d.hydrateProxyUser(state.domain.pu),
        age: state.domain.age,
        isShowAllUsers: state.dashboard.isShowAllUsers,
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth"
    };
};
const mapDispatchToProps = (dispatch) => {
    return {

        switchToMyChartUser: (user, isSeeAllSelected, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, isSeeAllSelected, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        },
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyChartProxySelector));
